import Calendar from '../../../../../../assets/images/landing/advantages/calendar.svg';
import Exchange from '../../../../../../assets/images/landing/advantages/exchange.svg';
import Convert from '../../../../../../assets/images/landing/advantages/convert.svg';
import Search from '../../../../../../assets/images/landing/advantages/search.svg';
import Time from '../../../../../../assets/images/landing/advantages/time.svg';
import Like from '../../../../../../assets/images/landing/advantages/like.svg';

export const referrals = [
  {
    photo: Like,
    title: 'referrals_landing_advantages_item_1_title',
    subtitle: 'referrals_landing_advantages_item_1_subtitle',
  },
  {
    photo: Convert,
    title: 'referrals_landing_advantages_item_2_title',
    subtitle: 'referrals_landing_advantages_item_2_subtitle',
  },
  {
    photo: Calendar,
    title: 'referrals_landing_advantages_item_3_title',
    subtitle: 'referrals_landing_advantages_item_3_subtitle',
  },
  {
    photo: Time,
    title: 'referrals_landing_advantages_item_4_title',
    subtitle: 'referrals_landing_advantages_item_4_subtitle',
  },
  {
    photo: Search,
    title: 'referrals_landing_advantages_item_5_title',
    subtitle: 'referrals_landing_advantages_item_5_subtitle',
  },
  {
    photo: Exchange,
    title: 'referrals_landing_advantages_item_6_title',
    subtitle: 'referrals_landing_advantages_item_6_subtitle',
  },
];
